/**
 * Firmy a živnostníci, kteří s námi spolupracují – sekce „Spolupracují s námi"
 * na homepage (pruh s logy + případné reference).
 *
 * PRAVIDLA (zákon o ochraně spotřebitele, GDPR, pravidla majitele):
 * - Jen SKUTEČNÍ partneři a zákazníci, a to s jejich SOUHLASEM se zveřejněním
 *   názvu / loga. Žádné vymyšlené firmy ani „ukázková" loga.
 * - Reference (`quote`) jen doslovně tak, jak ji partner napsal, s uvedením
 *   jména a funkce. Nic neupravovat ani nevymýšlet.
 * - Dokud je seznam prázdný, sekce ukazuje jen nabídku pro firmy (typy
 *   zákazníků, pro které pracujeme) – žádná jména. Při 1–3 partnerech jsou
 *   jejich loga staticky pod pruhem, od 4 partnerů běží v pruhu loga.
 *
 * Příklad položky:
 * {
 *   name: 'Penzion U Lesa',                 // povinné – oficiální název
 *   type: 'Penzion',                        // krátký popis oboru
 *   logo: '/partners/penzion-u-lesa.svg',   // volitelné – soubor do public/partners/
 *   url: 'https://penzion-u-lesa.cz',       // volitelné – web partnera
 *   quote: 'Doslovný text reference…',      // volitelné
 *   person: 'Jana Nováková, majitelka',     // povinné, pokud je quote
 * }
 */
export const PARTNERS = [
  // Souhlas se zveřejněním reference: e-mail Jany Dudkové (office manažerka)
  // z 12. 10. 2026 – „referenci si na web klidně dát můžete – mám povoleno
  // od pana jednatele“. Zakázka: vyčištění a úprava zeleně areálu v Libišanech
  // (10/2026). Doslovnou recenzi slíbila poslat – pak doplnit `quote` + `person`.
  {
    name: 'INEREZ',
    type: 'Údržba zeleně firemního areálu',
    logo: '/partners/inerez.png',
    width: 554,
    height: 96,
    url: 'https://www.inerez.cz/',
    // Recenze z Firmy.cz od zákaznice z INEREZ (12. 10. 2026, 5 hvězdiček) – doslovně
    quote: 'Skvělá zkušenost a skvělý výsledek!\nProfesionalita: Osobní obhlídka rozsahu a nabídka dodaná přesně v dohodnutém termínu.\nRychlost: Termín realizace jsme získali téměř okamžitě.\nNasazení: Tým pracoval poctivě od rána do večera.\nKvalita: Předání proběhlo hladce a výsledek stojí za to.\nJeště jednou moc děkujeme!',
    person: 'Laanja – hodnocení na Firmy.cz',
    rating: 5,
    date: '12. 10. 2026',
  },
];

// Pro koho pracujeme – zobrazí se v pruhu, dokud nejsou doplnění partneři.
// Jde o nabídku služeb, ne o tvrzení o konkrétních zákaznících.
export const CLIENT_TYPES = [
  'Firemní areály',
  'Penziony a ubytování',
  'Bytové domy a SVJ',
  'Obce a veřejná zeleň',
  'Realitní kanceláře',
  'Živnostníci a provozovny',
  'Chalupy a rekreační objekty',
  'Správci nemovitostí',
];

export const partnersWithQuote = () => PARTNERS.filter((p) => p.quote && p.person);
